import './styles.scss';

import { Collapse } from 'react-bootstrap';
import { Datetime } from '@/utils/dates';
import { ManifestWithRoutes } from '../../api/services';
import RouteCard from '../RouteCard';
import { useState } from 'react';

interface HistoryCardProps {
  data: ManifestWithRoutes;
}

const HistoryCard = ({ data }: HistoryCardProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(true);
  if (!data.manifestHistoryId) return <RouteCard route={data.routes[0]} />;
  return (
    <div className="HistoryCard d-flex flex-column gap-3">
      <div className="d-flex flex-nowrap justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <span className="icon-container icon-bg-success rounded-circle d-flex justify-content-center align-items-center">
            <i className="sv sv-folder text-green" />
          </span>
          <span className="text-muted">Manifest Import</span>
        </div>
      </div>
      <div className="HistoryCard-Body flex-grow-1">
        <div className="HistoryCard-Header">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column gap-2">
              <span>{data.filename || 'Unknown'}</span>
              <span className="d-flex align-items-center gap-2">
                <i className="sv sv-clock3" />
                <span className="text-muted">{new Datetime().setAsUTC(data.createdAt).format('MM/DD/YY, HH:mm:ss')}</span>
              </span>
            </div>
            <div className="d-flex align-items-center gap-2 pointer" onClick={() => setIsExpanded((current) => !current)}>
              <span className="text-muted">{data.routes.length} Routes</span>
              <i className={`fas fs-4 ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
            </div>
          </div>
        </div>
        <Collapse in={isExpanded}>
          <div>
            <div className="RouteList">
              {data.routes.map((route) => (
                <RouteCard route={route} key={route.id} condensed />
              ))}
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default HistoryCard;
